import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { api } from "../../Services/api";
import { useEffect } from "react";
import { IGuest } from "../../Interfaces";
import { toast } from "react-toastify";

interface IProviderProps {
  children: ReactNode;
}

interface IGuestData {
  guests: IGuest[];
  addNewGuest: (guest: IGuest) => void;
  editGuest: (guest: IGuest) => void;
  deleteGuest: (id: number) => void;
  setGuests: Dispatch<SetStateAction<IGuest[]>>;
}

export const GuestsContext = createContext<IGuestData>({} as IGuestData);

export const GuestsProvider = ({ children }: IProviderProps) => {
  const [guests, setGuests] = useState<IGuest[]>([]);
  const [guestId, setGuestId] = useState<number | undefined>(0);

  useEffect(() => {
    api
      .get("/guests")
      .then((response) => {
        setGuests(response.data);
      })
  }, []);

  const addNewGuest = (guest: IGuest) => {
    api
      .post("/guests", guest)
      .then((_) => {
        toast.success("Hóspede Adicionado");

        setGuests([...guests, guest]);
      })
      .catch((_) => 
        toast.error("Erro ao adicionar Hóspede"));
  };

  const editGuest = (guest: IGuest) => {
    const { id } = guest;
    const firstOcurr = guests.findIndex((el) => el.id === guest.id);
    guests.splice(firstOcurr, 1, guest);
    setGuestId(id);
  };

  useEffect(() => {
    if (guestId !== 0) {
      api
        .patch(`/guests/${guestId}`, guests)
        .then((_) => {
          toast.success("Hóspede editado");

          setGuestId(0);
        })
        .catch((_) => 
          toast.error("Erro ao editar Hóspede")
          );
    }
  }, [guestId, guests]);

  const deleteGuest = (id: number) => {
    api
      .delete(`/guests/${id}`)
      .then((_) => {
        toast.success("Hóspede deletado");
        api
          .get("/guests")
          .then((res) => {
            setGuests(res.data);
          })
          .catch((_) => 
            toast.error("Erro ao excluir Hóspede"));
      })
      .catch((_) => 
        toast.error("Erro ao excluir Hóspede"));
  };

  return (
    <GuestsContext.Provider
      value={{
        guests,
        addNewGuest,
        editGuest,
        deleteGuest,
        setGuests,
      }}
    >
      {children}
    </GuestsContext.Provider>
  );
};

export const useGuests = () => useContext(GuestsContext);
